module.exports = __webpack_public_path__ + "static/media/nzbusiness@3x.bf856f08.jpg";